/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type DecreaseCreditRequest = {
    ownerId: string;
    ownerType: DecreaseCreditRequest.ownerType;
    amount: number;
    notes?: string;
};
export namespace DecreaseCreditRequest {
    export enum ownerType {
        SHOP = 'SHOP',
        REVENUE = 'REVENUE',
        THIRD_PARTY = 'THIRD_PARTY',
        CLEARING = 'CLEARING',
        BANKS = 'BANKS',
        FINANCIER = 'FINANCIER',
    }
}

